import ReactECharts from "echarts-for-react";
import { useTranslation } from "react-i18next";

export default function StaffCharts() {
    const { t } = useTranslation();

    const repliesOption = {
        tooltip: {
            trigger: "axis"
        },

        grid: {
            left: 10,
            right: 20,
            top: 20,
            bottom: 20,
            containLabel: true
        },

        xAxis: {
            type: "value",
            splitLine: {
                lineStyle: {
                    type: "dashed",
                    color: "#e5e7eb"
                }
            }
        },

        yAxis: {
            type: "category",
            data: [
                "PhanCao Huân",
                "Nguyễn thị thủy linh",
                "Staff 3",
                "Staff 4",
                "Staff 5"
            ]
        },

        series: [
            {
                type: "bar",
                data: [150, 120, 90, 60, 30],
                barWidth: 16,
                itemStyle: {
                    color: "#f59e0b",
                    borderRadius: 6
                }
            }
        ]
    };



    const salesOption = {
        tooltip: {
            trigger: "axis"
        },

        grid: {
            left: 10,
            right: 20,
            top: 20,
            bottom: 20,
            containLabel: true
        },

        xAxis: {
            type: "value",
            splitLine: {
                lineStyle: {
                    type: "dashed",
                    color: "#e5e7eb"
                }
            }
        },

        yAxis: {
            type: "category",
            data: [
                "PhanCao Huân",
                "Nguyễn thị thủy linh"
            ]
        },

        series: [
            {
                type: "bar",
                data: [372.2, 12.222],
                barWidth: 16,
                itemStyle: {
                    color: "#f59e0b",
                    borderRadius: 6
                },
                label: {
                    show: true,
                    position: "right",
                    formatter: "{c} đ"
                }
            }
        ]
    };



    return (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

            {/* Replies */}

            <div className="bg-white dark:bg-[#1f1f1f] rounded-xl p-5 shadow-sm">

                <h3 className="text-gray-800 dark:text-gray-200 font-semibold mb-4">
                    {t('overview_report.top5_replies')}
                </h3>

                <ReactECharts
                    option={repliesOption}
                    style={{ height: 300 }}
                />

            </div>



            {/* Sales */}

            <div className="bg-white dark:bg-[#1f1f1f] rounded-xl p-5 shadow-sm">

                <h3 className="text-gray-800 dark:text-gray-200 font-semibold mb-4">
                    {t('overview_report.top5_sales')}
                </h3>

                <ReactECharts
                    option={salesOption}
                    style={{ height: 300 }}
                />

            </div>

        </div>
    );
}